import * as D from '../deps';

import * as CrosstabWorkers from './workers';

export default [
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
    handler: CrosstabWorkers.handleCrossTabPlay,
    concur: 'takeOnly',
  },
  {
    actionType: 'XTAB_PLAY',
    handler: CrosstabWorkers.handleCrossTabPlayAction,
    concur: 'takeLatest',
  },
];
